import { render, staticRenderFns } from "./report-parent-service-patients.vue?vue&type=template&id=3862df46&"
import script from "./report-parent-service-patients.vue?vue&type=script&lang=js&"
export * from "./report-parent-service-patients.vue?vue&type=script&lang=js&"
import style0 from "./report-parent-service-patients.vue?vue&type=style&index=0&id=3862df46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports